import { ChildFactory } from './childFactory';

import type { ChildEntity, ChildProps } from './childEntity';
import type { ChildIRepository } from './childIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

export class ChildRepository extends AppsyncRepositoryPvt<
  ChildEntity,
  ChildProps,
  ChildJson
> implements ChildIRepository {
  private factory = new ChildFactory();

  protected get entityName(): EntityName {
    return EntityName.WagakoAppChildChildEntity;
  }

  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
